import { useState } from 'react';
import { useRequest } from 'ahooks';
import { getDepts, getStudyList } from '../../../service/theme';
import { userStore } from '../../../store';
import { Toast } from 'antd-mobile';

export default function useService() {

    const [dataStudy, setDataStudy] = useState([]);
    const [allDept, setAllDept] = useState([]);
    const { page, pageSize } = userStore;

    const { loading, run: runStudy } = useRequest(() => getStudyList({
        page,
        pageSize
    }), {
        manual: true,
        onSuccess: (result, params) => {
            if (result.status) {
                const rows = result.data.rows;
                setDataStudy(rows)
            }
        },
        onError: (error) => {
            Toast.show({
                content: '请求课程出错了',
            })
        },
    });

    const { loading: loadingAllDept, run: runAllDept } = useRequest(() => getDepts({
        page,
        pageSize
    }), {
        manual: true,
        onSuccess: (res, param) => {
            if (res.status) {
                setAllDept(res.data.rows)
            }
        }
    })

    return { loading, dataStudy, runStudy, loadingAllDept, allDept, runAllDept }
}
